import { object } from 'common/helpers'
// import { User } from 'redux/models/user'


/*

Backend response structure for rest/user/profile

{
  avatar: null
  balance: 0
  birthday: null
  credits: { ecommerce: 0 }
  email: "1535993221610-promo@scentbird.com"
  fbPixelProperties: { em: "1535993221610-promo@scentbird.com", fn: "account", ln: "scentbird", ph: "", ge: "f", db: null, … }
  firstName: "Account"
  gaClientUid: "1260631450.1535993176"
  gender: "female"
  hasFinishedQuiz: false
  hasGift: false
  hasLimitedEditionProductInFirstMonth: false
  hasMarketingCoupon: true
  id: 1419691
  isCrawler: false
  lastName: "Scentbird"
  mixpanelClientUid: null
  needUpdateGender: false
  paymentOption: "creditCard"
  paymentStatus: "STANDARD"
  registrationDate: "2018-09-03T16:47:01Z"
  subUnpaid: false
}

*/

// export const initialState = new User
export const initialState = {
  isLoggedIn: false,
  isRegistered: false,
  firstName: 'Scentbird',
  lastName: '',
  gender: 'female',
  skinType: null,
  ageCategory: null,
  hasFinishedQuiz: false,
  finishedQuiz: {
    onboarding: false,
    recsNewQuiz: false,
  },
  hasMarketingCoupon: false,
  stats: {
    orders: 0,
    queue: 0,
    reviews: 0,
    ratedProducts: 0,
  },
  shipping: {}, // TODO replace {} with null or smth else?
  billing: {}, // TODO replace {} with null or smth else?
  hasPaymentData: false,
  card: {
    lastDigits: null,
    holderName: null,
    expirationDate: null,
  },
  gift: {},
  giftSubscription: {
    code: null,
    recipientEmail: null,
    gender: null,
    giverName: null,
    months: null,
    activated: false,
  },
  isCrawler: false,
  invitedFriends: [],
  referralCodes: null,
  credits: {}, // TODO replace {} with null or smth else?
  redeemCoupon: {}, // TODO replace {} with null or smth else?
  isSpecialCaseTokenValid: false,
}

export const update = (state, payload) => (
  object.mergeDeep(state, payload)
)

export const decreaseStatsQueueCount = (state) => (
  object.updateIn(state, [ 'stats', 'queue' ], (v) => v ? --v : 0)
)

export const increaseStatsQueueCount = (state) => (
  object.updateIn(state, [ 'stats', 'queue' ], (v) => ++v)
)

export const setGiftSubscription = (state, payload) => (
  { ...state, giftSubscription: payload }
)

export const setAgeAndSkinType = (state, { skinType, ageCategory }) => (
  { ...state, skinType, ageCategory }
)

export const removeGiftSubscription = (state) => (
  { ...state, giftSubscription: null }
)

export const activateGiftSubscription = (state) => (
  object.setIn(state, [ 'giftSubscription', 'activated' ], true)
)

export const updateFinishedQuiz = (state, { type, value }) => (
  object.setIn(state, [ 'finishedQuiz', type ], value)
)

export const removeGift = (state) => (
  { ...state, gift: {} }
)

export const removeSelectedGender = (state) => (
  object.remove(state, 'selectedGender')
)
